import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  CircularProgress,
} from "@material-ui/core";
import { useStyles } from "./index.styles";

const ImageSection = ({ label, imageUrl, classes }) => {
  if (!imageUrl) {
    return (
      <div className={classes.imageContainer}>
        <Typography className={classes.imageLabel}>{label}</Typography>
        <div className={classes.placeholder} data-testid={`${label.toLowerCase().replace(/\s/g, "-")}-placeholder`}>
          <Typography color="textSecondary">No Image Available</Typography>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.imageContainer}>
      <Typography className={classes.imageLabel}>{label}</Typography>
      <img
        src={imageUrl}
        alt={label}
        className={classes.image}
      />
    </div>
  );
};

const LPRImageDetailView = ({
  open,
  onClose,
  plateImageUrl,
  contextImageUrl,
  plateText,
  isLoading,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-testid="lpr-image-detail-dialog"
    >
      <DialogTitle>
        {plateText ? `Plate: ${plateText}` : "Image Detail"}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        {isLoading ? (
          <Grid container justify="center">
            <CircularProgress />
          </Grid>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <ImageSection
                label="Plate Image"
                imageUrl={plateImageUrl}
                classes={classes}
              />
            </Grid>
            <Grid item xs={12}>
              <ImageSection
                label="Context Image"
                imageUrl={contextImageUrl}
                classes={classes}
              />
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          color="primary"
          variant="contained"
          data-testid="lpr-image-detail-close-button"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LPRImageDetailView;
